import { cardAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(cardAnatomy.keys)

const baseStyle = definePartsStyle({
	container: {},
	header: {
		px: 4,
		pb: 0,
		pt: 4,
		fontSize: 'sm',
		fontWeight: '600',
		textTransform: 'uppercase',
		letterSpacing: 'wide',
	},
	body: { px: 4, py: 3, fontSize: 'sm' },
	footer: {
		px: 4,
		pt: 0,
		pb: 4,
		gap: 4,
	},
})

const variants = {
	filled: definePartsStyle({
		container: {
			borderWidth: '1px',
			borderColor: 'gray.200',
		},
	}),
	inactive: definePartsStyle({
		container: {
			backgroundColor: 'transparent',
			borderWidth: '1px',
			borderColor: 'gray.300',
			borderStyle: 'dashed',
		},
	}),
	primary: definePartsStyle({
		container: {
			bgGradient: 'linear(to-br, primary.600, primary.800)',
			color: 'white',
		},
	}),
	success: definePartsStyle({
		container: {
			bgGradient: 'linear(to-br, green.600, green.800)',
			color: 'white',
		},
	}),
	warning: definePartsStyle({
		container: {
			bgGradient: 'linear(to-br, orange.600, orange.800)',
			color: 'white',
		},
	}),
	danger: definePartsStyle({
		container: {
			bgGradient: 'linear(to-br, red.600, red.800)',
			color: 'white',
		},
	}),
}

export const cardTheme = defineMultiStyleConfig({ baseStyle, variants })
